module.exports = __webpack_public_path__ + "static/media/calendar-icon.5e3fc98d.svg";